import React from "react";
import * as Icons from "lucide-react";

export default function PracticeAreaCard({ area, attorneyCount, onClick }) {
  const Icon = Icons[area.icon] || Icons.Scale;
  return (
    <button
      onClick={onClick}
      className="group bg-[#11203c] p-8 text-left flex flex-col justify-start transition-colors duration-300 hover:bg-[#1a2c4e] focus:outline-none focus:bg-[#1a2c4e]"
    >
      <div className="flex items-start gap-4">
        <div className="shrink-0 w-12 h-12 border border-[#4a6d8c] flex items-center justify-center group-hover:border-[#d4b87a] group-hover:bg-[#d4b87a]/10 transition-colors">
          <Icon className="w-5 h-5 text-[#a8c4dc] group-hover:text-[#d4b87a] transition-colors" />
        </div>
        <div className="flex-1">
          <h3 className="font-serif text-2xl mb-3 min-h-[3.75rem] leading-tight">{area.title}</h3>
          <p className="text-stone-300 text-sm leading-relaxed">{area.summary || area.description}</p>
          <div className="mt-4 flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-[#d4b87a]">
            <span>
              View {attorneyCount} {attorneyCount === 1 ? "Attorney" : "Attorneys"}
            </span>
            <Icons.ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </div>
        </div>
      </div>
    </button>
  );
}
